import styled from 'vue-styled-components'
const ReHeight = styled.div`
  pointer-events: all;
  position: absolute;
  width: 32px;
  height: 24px;
  background-color: #0B7BBC;
  border-radius: 4px;
  bottom: -9px;
  right: 32%;
  margin: auto;
  max-width: 100%;
  cursor: row-resize;
  z-index: 5;
`
const ToolLabel = styled.div`
  position: absolute;
  background-color: rgba(0, 0, 0, 0.5);
  color: #ffffff;
  height: 25px;xr
  width: fit-content;
  white-space: nowrap;
  top: 5px;
  left: 100%;
  border-radius: 4px;
`
export {

  ReHeight,
  ToolLabel
}